export enum PromotionStatusEnum {
  DRAFT = 'draft',
  ACTIVE = 'active',
  ENDED = 'ended'
}
